/**
 * FeatureFlag Component
 * Description: Conditionally renders children based on the status of a feature flag.
 * @param {string} name - The name of the feature flag to check.
 * @param {node} fallback - Content to render if the feature flag is disabled.
 * @param {node} children - Content to render if the feature flag is enabled.
 * @return {JSX.Element}
 * @example
 * <FeatureFlagWrapper name="newFeature" fallback={<OldComponent />}>
 *   <NewComponent />
 * </FeatureFlagWrapper>
 */
import React from "react";
import PropTypes from "prop-types";
import { isFeatureEnabled } from "./GlobalTools";

export default function FeatureFlagWrapper(props) {
  const { name = "", fallback = null, children } = props;
  const show = isFeatureEnabled(name);

  return <>{show ? children : fallback}</>;
}

FeatureFlagWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};
